import { render, staticRenderFns } from "./ma-code.vue?vue&type=template&id=00332b8a"
import script from "./ma-code.vue?vue&type=script&lang=js"
export * from "./ma-code.vue?vue&type=script&lang=js"
import style0 from "./ma-code.vue?vue&type=style&index=0&id=00332b8a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/amytran/ShopifyProjects/titan22-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00332b8a')) {
      api.createRecord('00332b8a', component.options)
    } else {
      api.reload('00332b8a', component.options)
    }
    module.hot.accept("./ma-code.vue?vue&type=template&id=00332b8a", function () {
      api.rerender('00332b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ma-code.vue"
export default component.exports